import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Add, Visibility, VisibilityOff, FilterList, Send} from '@mui/icons-material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import Dialog from 'components/Dialog'
import FilterDialogContent from 'components/FilterDialogContent'
import Feedbacks from 'components/Feedbacks'
import ViewConfig from 'components/ViewConfig'
import Views from './Views'
import Confirmation from 'components/Confirmation'
import Search from 'components/Search'
import {setTextFilter,
    setFeedback,
    createView,
    deleteView,
    updateView,
    reorderViews,
	cloneView} from 'modules/collection/actions'
import {fetchAddCol} from 'modules/entities/actions'
import {deleteKey, getKeysFeedback} from 'modules/statistics/actions'
import ColumnIcon from './ColumnIcon'

const Preset = styled.div`
    background-color: rgba(160, 183, 190, .24);
    align-items: center;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 25px;
    width: 25px;
    min-width: 25px;
    transition: background-color 250ms cubic-bezier(.55, 0, .1, 1);

    :hover {
        background-color: rgba(160, 183, 190, .35);
    }
`

const Container = styled.div`
    align-items: center;
    display: flex;
    padding: ${props => props.mobile ? '7px 10px 10px 10px' : '0 16px 10px 16px'};
    box-sizing: border-box;
    justify-content: space-between;

    > div {
        display: flex;
        align-items: center;
    }
`

const Badge = styled.span`
    background-color: #ffc300;
    line-height: 16px;
    font-family: Helvetica;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    text-align: center;
    position: absolute;
    font-weight: 700;
    overflow: hidden;
    font-size: 12px;
    color: #fff;
    right: -5px;
    top: 0;
`

const Filter = styled.div`
    position: relative;
    margin: 0 20px;
    cursor: pointer;
`

const Feedback = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 20px;
    cursor: pointer;
`

const ButtonAdd = styled.div`
    font-size: 16px;
    color: #415dd4;
    align-items: center;
    cursor: pointer;
    display: flex;

    > svg {
        margin-right: 8px;
        min-width: 32px;
        min-height: 32px;
    }
`

class TableMenu extends React.Component {
    constructor(props) {
        super(props)

		this.search = React.createRef()

        this.state = {
            open: null,
            viewId: null,
            pattern: '',
            viewsList: null
        }
    }

    componentDidMount() {
        if (this.props.entityId) {
            this.props.getKeysFeedback(this.props.entityId)
        }
    }

    componentDidUpdate(props) {
        if (this.props.pattern === '' && this.search.current.value) {
            this.search.current.value = ''
        }

        if (props.entityId !== this.props.entityId && this.props.entityId) {
            this.props.getKeysFeedback(this.props.entityId)
        }
    }

    handleSearch = (e) => {
        this.props.setTextFilter(e.target.value)
    }

    handleClear = () => {
        this.props.setTextFilter('')
        this.search.current.value = ''
    }

    openViews = (e) => {
        this.setState({
            viewsList: e.currentTarget
        })
    }

    closeViews = () => {
        this.setState({
            viewsList: null
        })
    }

    selectView = (id) => {
        this.handleSelectView(id)
        this.closeViews()
    }

    openFilter = () => {
        this.setState({
            open: 'filter'
        })
    }

    openFeedback = () => {
        this.setState({
            open: 'feedback'
        })
    }

    handleOpen = (e, view, type) => {
        if (view && type) {
            this.setState({
                open: type,
                viewId: view
            })
        } else {
            if (this.props.views.find(item => item.isGlobal)) {
                this.setState({
                    open: 'view'
                })
            } else {
                this.setState({
                    anchorEl: e.currentTarget
                })
            }
        }
    }

    handleClose = () => {
        this.setState({
            open: null,
            viewId: null
        })
    }

    handleSelectView = (id) => {
        this.props.handleSelectView(id)
    }

    onReorderViews = (order) => {
        this.props.reorderViews(this.props.listId, order)
    }

    handleExclude = () => {
        this.props.deleteView(this.props.listId, null, false)
        this.handleClose()
    }

    handleCloseMenu = () => {
        this.setState({
            anchorEl: null
        })
    }

    handleCreate = () => {
        this.setState({
            open: 'view'
        })
        this.handleCloseMenu()
    }

    handleInclude = () => {
        this.props.createView({}, this.props.listId, true)
        this.handleCloseMenu()
    }

    createCol = () => {
        this.props.fetchAddCol(this.props.entityId)
    }

    render() {
        const { intl, permissions, keys } = this.props

        return (
            <Container mobile={this.props.mobile}>
                <div>
                    <Search value={this.props.pattern}
						onClick={this.handleClear}
						onChange={this.handleSearch}
						ref={this.search}
					/>
                    {this.props.mobile &&
                        <FilterList onClick={this.openViews} style={{marginLeft: '20px'}}/>
                    }
                    {!this.props.mobile &&
                        <React.Fragment>
                            <Tooltip
                                title={intl.formatMessage({id: "table.advanced_filtering"})}
                                placement="top"
                            >
                                <Filter onClick={this.openFilter}>
                                    <FilterList />
                                    {!!this.props.filterCount &&
                                        <Badge>{this.props.filterCount}</Badge>
                                    }
                                </Filter>
                            </Tooltip>
                            {!!this.props.hiddenCount &&
                                <React.Fragment>
                                    {this.props.showHidden ?
                                        <Tooltip
                                            title={intl.formatMessage({id: "table.no_hidden_fields"})}
                                            placement="top"
                                        >
                                            <VisibilityOff onClick={this.props.toggleVisibility} sx={{marginRight: '20px', cursor: 'pointer', color: '#415dd4'}} />
                                        </Tooltip> :
                                        <Tooltip
                                            title={intl.formatMessage({id: "table.hidden_fields"})}
                                            placement="top"
                                        >
                                            <Visibility onClick={this.props.toggleVisibility} sx={{marginRight: '20px', cursor: 'pointer'}} />
                                        </Tooltip>
                                    }
                                </React.Fragment>
                            }
                            {!!keys && !!keys.length &&
                                <Tooltip
                                    title={intl.formatMessage({id: "feedback.show_feedback"})}
                                    placement="top"
                                >
                                    <Feedback onClick={this.openFeedback}>
                                        <Send />
                                        {this.props.feedback &&
                                            <React.Fragment>
                                                <span style={{marginLeft: '5px'}}>
                                                    {this.props.feedback.name}
                                                    {this.props.feedback.period && ' - ' + this.props.feedback.period}
                                                </span>
                                            </React.Fragment>
                                        }
                                    </Feedback>
                                </Tooltip>
                            }
                        </React.Fragment>
                    }
                </div>
                {!this.props.mobile &&
                    <div>
                        {this.props.listId && permissions.Designer &&
                            <Preset onClick={this.handleOpen}>
                                <Add />
                            </Preset>
                        }
                        {this.props.listId && this.props.isLoaded &&
                            <Views
                                views={this.props.views}
                                permissions={permissions.Designer}
                                handleSelectView={this.handleSelectView}
                                handleOpen={this.handleOpen}
                                active={this.props.currentViewId}
                                index={this.props.currentViewIndex}
                                onReorderViews={this.onReorderViews}
                            />
                        }
                        {permissions.Designer &&
                            <ButtonAdd onClick={this.createCol}>
                                <ColumnIcon />
                                {intl.formatMessage({id: "table.add_field"})}
                            </ButtonAdd>
                        }
                        <Dialog
                            fullWidth={this.state.open === 'exclude' ? false : true}
                            maxWidth={this.state.open === 'filter' ? 'md' : 'sm'}
                            open={!!this.state.open}
                            onClose={this.handleClose}
                        >
                            {this.state.open === 'feedback' &&
                                <Feedbacks
									handleClose={this.handleClose}
                                    keys={keys}
                                    feedback={this.props.feedback}
                                    setFeedback={this.props.setFeedback}
                                    permissions={permissions}
                                    deleteKey={this.props.deleteKey}
                                    entityId={this.props.entityId}
                                />
                            }
                            {this.state.open === 'filter' &&
                                <FilterDialogContent
                                    onClose={this.handleClose}
                                    globalView={this.props.globalView}
                                />
                            }
                            {this.state.open === 'view' &&
                                <ViewConfig
                                    onClose={this.handleClose}
                                    listId={this.props.listId}
                                    view={this.state.viewId ?
                                        this.props.views.find(item => item.id === this.state.viewId) : null}
                                    handleClose={this.handleClose}
                                    deleteView={this.props.deleteView}
                                    updateView={this.props.updateView}
                                    createView={this.props.createView}
									cloneView={this.props.cloneView}
                                />
                            }
                            {this.state.open === 'exclude' &&
                                <Confirmation
                                    title={intl.formatMessage({id: "app.confirm_action"})}
                                    text={intl.formatMessage({id: "table.confirm_view_hide"})}
                                    button={intl.formatMessage({id: "app.confirm_hide"})}
                                    handleConfirm={this.handleExclude}
                                    handleClose={this.handleClose}
                                />
                            }
                        </Dialog>
                        <Menu
                            anchorEl={this.state.anchorEl}
                            open={!!this.state.anchorEl}
                            onClose={this.handleCloseMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={this.handleInclude}>
                                {intl.formatMessage({id: "table.restore_view_all"})}
                            </MenuItem>
                            <MenuItem onClick={this.handleCreate}>
                                {intl.formatMessage({id: "table.create_view"})}
                            </MenuItem>
                        </Menu>
                    </div>
                }
                {this.props.mobile &&
                    <Menu
                        anchorEl={this.state.viewsList}
                        open={!!this.state.viewsList}
                        onClose={this.closeViews}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {this.props.views.map(item =>
                            <MenuItem key={item.id} selected={this.props.currentViewId === item.id} onClick={() => this.selectView(item.id)}>
                                <span className={"entity-icon-small entity-icon-" + item.icon} />
                                {item.name}
                            </MenuItem>
                        )}
                    </Menu>
                }
            </Container>
        )
    }
}

const mapStateToProps = ({login, collection, statistics}) => ({
    permissions: login.permissions,
    views: collection.views,
    currentViewIndex: collection.currentViewIndex,
    currentViewId: collection.currentViewId,
    pattern: collection.pattern,
    feedback: collection.feedback,
    keys: statistics.keys,
	isLoaded: collection.isLoaded
})

export default connect(mapStateToProps, {
    createView,
    deleteView,
    updateView,
    reorderViews,
    fetchAddCol,
    setTextFilter,
    setFeedback,
    deleteKey,
    getKeysFeedback,
	cloneView
})(injectIntl(TableMenu))
